"use strict";function debug(){for(var e=[],o=0;o<arguments.length;o++)e[o]=arguments[o];"development"===process.env.NODE_ENV&&console.debug.apply(console,e)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.debug=void 0,exports.debug=debug;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-alice-carousel/lib/utils/debug.js
// module id = 1046
// module chunks = 0